import { withForm } from "@/components/ui/forms/hooks/useFormHook"
import { Text } from "@/components/ui/baseUi/text"
import {
  coachOfferFormDefaultValues,
  CoachOfferValidationSchema,
} from "@/modules/coachOffers/types/coachOfferFormTypes"
import { useLanguage } from "@/modules/language/hooks/useLanguage"
import { HUImageForm } from "@/modules/ui/components/huImageForm"
import { word } from "@modules/core/utils/i18n"
import { useStore } from "@tanstack/react-form"
import { NotepadTextIcon, TriangleAlertIcon } from "lucide-react"

export const CoachOfferStep2View = withForm({
  defaultValues: coachOfferFormDefaultValues,
  render: function CoachOfferStep2ViewInner({ form }) {
    const language = useLanguage()

    const image = useStore(form.baseStore, (state) => state.values.image)

    return (
      <div className="flex flex-col gap-6">
        <div className="flex items-center gap-2">
          <NotepadTextIcon color="currentColor" className="size-5" />
          <Text fontStyle="TM">{word("coach.offers.form.infos.generalInfo")}</Text>
        </div>

        <form.AppField
          name="image"
          validators={{
            onChange: CoachOfferValidationSchema(language).shape.image,
          }}
        >
          {(field) => (
            <field.Field>
              <field.Label className="uppercase">{word("coach.offers.form.cover.label")}</field.Label>
              <field.Content>
                <field.Description className="m-0! flex flex-row items-start gap-1.5 text-textOnSurface-subtle">
                  <TriangleAlertIcon color="currentColor" className="size-5" />
                  {word("coach.offers.form.cover.description")}
                </field.Description>
                <HUImageForm
                  type="cover"
                  image={image}
                  setImage={(image) => void form.setFieldValue("image", image ?? null)}
                  placeHolder={{ message: word("coach.offers.form.cover.placeholder") }}
                />
                <field.Message />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <form.AppField
          name="name"
          validators={{
            onChange: CoachOfferValidationSchema(language).shape.name,
            onBlur: CoachOfferValidationSchema(language).shape.name,
          }}
        >
          {(field) => (
            <field.Field>
              <field.Label required>
                {word("global.title")}              </field.Label>
              <field.Content>
                <field.Input placeholder={word("coach.offers.form.title.placeholder")} />
                <field.Message />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>

        <form.AppField
          name="description"
          validators={{
            onChange: CoachOfferValidationSchema(language).shape.description,
            onBlur: CoachOfferValidationSchema(language).shape.description,
          }}
        >
          {(field) => (
            <field.Field>
              <field.Label required>
                {word("global.description")}              </field.Label>
              <field.Content>
                <field.Textarea placeholder={word("coach.offers.form.description.placeholder")} />
                <field.Message />
              </field.Content>
            </field.Field>
          )}
        </form.AppField>
      </div>
    )
  },
})
